import { assertCondition } from '../../../../utils/types';
import { PathModeKey, QueryType } from '../../../../utils/apollo/graphqlSchema';
import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IAnalysesState } from '../types';

export const pathSetDisplaySeq = (
  draft: Draft<IAnalysesState>,
  action: PayloadAction<{
    id: string;
    pathProps: any;
  }>,
) => {
  const { id: analysisId, pathProps } = action.payload;
  const { displaySeq } = pathProps;
  const chartSettings = draft[analysisId].settings.chartSettings;
  chartSettings.displaySeq = displaySeq;
};

export const pathSetMaxSeq = (
  draft: Draft<IAnalysesState>,
  action: PayloadAction<{
    id: string;
    pathProps: any;
  }>,
) => {
  const { id: analysisId, pathProps } = action.payload;
  const { maxSeq } = pathProps;
  const chartData = draft[analysisId].chartData;
  assertCondition(
    chartData?.queryType === QueryType.Path &&
      chartData?.mode === PathModeKey.Sankey,
  );
  chartData.maxSeq = maxSeq;
};

export const pathSetEventsPerStep = (
  draft: Draft<IAnalysesState>,
  action: PayloadAction<{
    id: string;
    pathProps: { eventsPerStep: number };
  }>,
) => {
  const { id: analysisId, pathProps } = action.payload;
  const { eventsPerStep } = pathProps;
  const chartSettings = draft[analysisId].settings.chartSettings;

  chartSettings.pathEventsPerStep = Math.max(eventsPerStep, 1);
};
